module.exports = __webpack_public_path__ + "static/media/s_weight_lifting.c630f3de.mp3";